module.exports = __webpack_public_path__ + "img/symbol_3.e6c64ab0.png";